import { memo } from 'react';
import styles from '@components/ProductCardNew/ProductImage/PackshotImageHover/PackshotImageHover.styles';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import { IThumbnailFormats } from '@features/categories/typescript';
type PropsType = {
  url: string;
  alt: string;
  thumbnailFormats?: IThumbnailFormats;
  thumbnails?: Record<string, IThumbnailFormats | undefined>;
  isOpened?: boolean;
  isSmall?: boolean;
  isSlider?: boolean;
};
const PackshotImageHover = memo(({
  url,
  alt,
  thumbnailFormats,
  thumbnails,
  isOpened = false,
  isSmall = false,
  isSlider = false
}: PropsType) => {
  if (!url || url === '') return null;
  return <ResponsiveImage image={url} thumbnailFormats={thumbnailFormats} thumbnails={thumbnails} alt={alt} objectFit="contain" sx={styles.hoverImage(isOpened, isSmall, isSlider)} className="hoverImage" />;
});
PackshotImageHover.displayName = 'PackshotImageHover';
export default PackshotImageHover;